import { render, staticRenderFns } from "./PaginationRight.vue?vue&type=template&id=27a75f79&scoped=true&"
import script from "./PaginationRight.vue?vue&type=script&lang=js&"
export * from "./PaginationRight.vue?vue&type=script&lang=js&"
import style0 from "./PaginationRight.vue?vue&type=style&index=0&id=27a75f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a75f79",
  null
  
)

export default component.exports